// VirtualizedListbox.js
import React from 'react';
import { VariableSizeList } from 'react-window';
import { styled } from '@mui/material/styles';

const StyledListItem = styled('li')({
  listStyle: 'none',
  paddingTop: '2px',
  paddingBottom: '2px',
  lineHeight: '1.2',
});

const VirtualizedListbox = React.forwardRef(function VirtualizedListbox(props, ref) {
  const { children, ...other } = props;
  const items = React.Children.toArray(children);
  const itemCount = items.length;

  // Set desired row height
  const ITEM_SIZE = 32; // smaller than the old 48px
  // Fixed container height when there are at least 8 items
  const CONTAINER_HEIGHT = 384;
  // If there are fewer than 8 items, use a height just large enough for them.
  const height = itemCount >= 8 ? CONTAINER_HEIGHT : itemCount * ITEM_SIZE;

  return (
    <div ref={ref} className="virtualized-listbox" {...other}>
      <VariableSizeList
        height={height}
        width="100%"
        itemCount={itemCount}
        itemSize={() => ITEM_SIZE}
        overscanCount={5}
        innerElementType="ul"
      >
        {({ index, style }) => (
          <StyledListItem style={style}>
            {items[index]}
          </StyledListItem>
        )}
      </VariableSizeList>
    </div>
  );
});

export default VirtualizedListbox;